<template>
  <section class="jd">
    <!-- Overview -->
    <div class="jd-section jd-section-overview">
      <jd-cover :company="job.company" :employment-type="employmentType" :job-name="jobName" />
      <span class="section-break" />
      <jd-carrer-level :level="carrerLevel" />
      <jd-features
        :districts="districts"
        :hourly-salary-range="hourlySalaryRange"
        :monthly-salary-range="monthlySalaryRange"
        :vacancy="vacancy"
        :working-day-range="workingDayRange"
        :working-hour-range="workingHourRange"
      />
      <div v-if="relativePostedDate" class="jd-posted-on">
        <svg-posted-on class="jd-posted-on__icon" />
        <p class="jd-posted-on__text">{{ relativePostedDate }}</p>
      </div>
    </div>
    <!-- Job duty -->
    <jd-duty :job-description="jobDescription" />
    <!-- Allowances -->
    <jd-allowances :allowances="allowances" />
    <!-- Work locations -->
    <jd-locations :addresses="addresses" :address-on-map="addressOnMap" :districts-label="districtsLabel" />
    <!-- Shifts -->
    <jd-shifts
      :end-date="endDate"
      :shifts="shifts"
      :start-date="startDate"
      :is-alternative-sat="isAlternativeSat"
      :is-shift-required="isShiftRequired"
    />
    <!-- Job requirements -->
    <jd-requirements :job="job" />
  </section>
</template>

<script>
import JobCarrerLevel from './jobCarrerLevel'
import JobDetailAllowances from './jobDetailAllowances'
import JobDetailCover from './jobDetailCover'
import JobDetailDuty from './jobDetailDuty'
import JobDetailFeatures from './jobDetailFeatures'
import JobDetailLocations from './jobDetailLocations'
import JobDetailRequirements from './jobDetailRequirements'
import JobDetailShifts from './jobDetailShifts'
import JobMixin from '../../../mixins/job'
import SvgPostedOn from '../../../assets/svg/posted_on.svg'

export default {
  components: {
    'jd-allowances': JobDetailAllowances,
    'jd-carrer-level': JobCarrerLevel,
    'jd-cover': JobDetailCover,
    'jd-duty': JobDetailDuty,
    'jd-features': JobDetailFeatures,
    'jd-locations': JobDetailLocations,
    'jd-requirements': JobDetailRequirements,
    'jd-shifts': JobDetailShifts,
    'svg-posted-on': SvgPostedOn,
  },
  mixins: [JobMixin],
}
</script>

<style lang="postcss" scoped>
.jd-posted-on {
  @apply flex items-center mb-2;
}
.jd-posted-on__icon {
  @apply mr-2 text-grey-medium;
  width: 18px;
  height: 18px;
}
.jd-posted-on__text {
  @apply text-xs text-grey-medium;
}

@screen desktop {
  >>> p,
  >>> span {
    @apply text-17/4;
  }
  .jd-posted-on__icon {
    width: 20px;
    height: 20px;
  }
  .jd-posted-on__text {
    @apply text-sm;
  }
}
</style>
